export const MINIMAL_BUTTON_INTERNAL_PADDING = 70;
